import Modal from '@src/common/ModalPopup';
import { COUNTRY_CODE } from '@src/config/constant';
import { setNewMMVlist } from '@store/slices/commonId';
import { saveInsurance } from '@store/slices/insurance';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const isCountryId = COUNTRY_CODE ==='id' ? true : false;

export default function MMVModal(props: any) {
    let { show, handleClose, type, vehicleUsage, setType, setFieldItemValue,setEngineCapacity } = props
    const [options, setOptions] = useState([])
    const [originalList, setOriginalList] = useState([])
    const [value, setValue] = useState<any>(null)
    const [showOtherPopup, setShowOtherPopup] = useState(false)
    const [activeModalName, setActiveModalName] = useState(props.type)
    const [otherInputFields, setOtherInputFields] = useState<any>({})
    const [otherErrorFields, setOtherErrorFields] = useState<any>({})
    const [otherPopupFields, setShowOtherPopupFields] = useState<string[]>([])

    const commonState = useSelector((state: any) => state.common)
    const insuranceState = useSelector((state: any) => state.insurance)

    const dispatch: any = useDispatch()
    const commonIdState = useSelector((state: any) => state.commonId)


    const handleSearch = (searchKeyword: string) => {
        let updatedList = options?.filter((e: any) => e?.label?.toLowerCase()?.includes(searchKeyword?.toLowerCase()))
        setOptions(updatedList)
        setValue(searchKeyword)

        if (!searchKeyword) {
            setOptions(originalList)
        }
    }

    const handleSelection = (element: any) => {
        let params: any = { ...insuranceState?.createInsurance }
        if(type === "version"){
            setEngineCapacity(element);
        }
        if (element?.label?.toLowerCase() === 'other') {
            setShowOtherPopup(true)
            handleClose()
            return
        }

        //reset mmv
        let resetKeys = (type === 'make') ? ['model', 'version'] : (type === 'model' ? ['version'] : [])
        for (let key of resetKeys) {
            delete params[key]
            delete params[key + '_name']
        }

        setValue(element.label)
        dispatch(saveInsurance({ ...params, [type]: element.value, [type + '_name']: element.label }))

        const { make_name, model_name } = insuranceState?.createInsurance
        const mmv = type === 'make' ? element.label : (type === 'model' ? make_name + " " + element.label : make_name + " " + model_name + " " + element.label)
        setFieldItemValue(mmv)

        let newType = (type === 'make') ? 'model' : (type === 'model' ? 'version' : null)
        if(isCountryId) dispatch(setNewMMVlist({[type + '_id']:element}))
        if (!newType) {
            handleClose()
            setType('make')
            if(isCountryId){
                props?.updateItem(props.sectionIndex,'version',element.value)
            }
            return
        }
        setType(newType)

        if(isCountryId) props.fetchMMV(newType,element.value)
    }

    const handleOtherPopupChange = (field: any, value: any) => {
        setOtherInputFields((prev: any) => ({ ...prev, [field]: 0, [field + "_name"]: value }))
    }

    const validateOtherInputFields = () => {
        let isError = false
        let errors: any = {}
        let keysToCheck = otherPopupFields

        for (let key of keysToCheck) {
            let updatedKey = key + "_name"
            if (!(otherInputFields?.[updatedKey])) {
                isError = true
                errors[updatedKey] = `This field is required`
            }
        }

        setOtherErrorFields(errors)
        return isError
    }

    const handleOtherModalSaveClick = () => {
        let checkError = validateOtherInputFields()
        if (checkError) return

        const mergedInsurance = { ...insuranceState?.createInsurance, ...otherInputFields };
        dispatch(saveInsurance(mergedInsurance))
        const { make_name, model_name, version_name } = otherInputFields;
        const mmv = [
            make_name || insuranceState?.createInsurance?.make_name, 
            model_name || insuranceState?.createInsurance?.model_name, 
            version_name || insuranceState?.createInsurance?.version_name
        ].filter(Boolean).join(" ");
        setFieldItemValue(mmv)

        // Keep newMMVlist (the state the final submit payload reads make/model/version
        // and their *_name fields from) in sync with manually entered "Other" values.
        // Without this, model/model_name/version/version_name stay undefined after an
        // "Other" selection and the create-lead API call fails validation
        // (e.g. "model must be a number conforming to the specified constraints").
        if (isCountryId) {
            const existingMMV = commonIdState?.newMMVlist || {};
            const updatedMMV: any = { ...existingMMV };

            if (otherPopupFields?.includes('make')) {
                updatedMMV.make_id = {
                    label: mergedInsurance?.make_name,
                    value: mergedInsurance?.make ?? 0,
                };
            }
            if (otherPopupFields?.includes('model')) {
                updatedMMV.model_id = {
                    label: mergedInsurance?.model_name,
                    value: mergedInsurance?.model ?? 0,
                };
            }
            if (otherPopupFields?.includes('version')) {
                updatedMMV.version_id = {
                    label: mergedInsurance?.version_name,
                    value: mergedInsurance?.version ?? 0,
                    model: updatedMMV?.model_id?.value ?? 0,
                    model_name: updatedMMV?.model_id?.label ?? mergedInsurance?.model_name,
                };
            }

            dispatch(setNewMMVlist(updatedMMV));
        }

        setShowOtherPopup(false)
        setType('make')
        setOtherInputFields({});
    }
    
    useEffect(() => {
        if (!isCountryId) return;

        const mmv = commonIdState?.newMMVlist?.[type];
        
        if (!mmv || !mmv.length) return;

        setOptions(mmv);
        setOriginalList(mmv)
    }, [isCountryId, type, show, commonIdState?.newMMVlist]);

    useEffect(() => {
        let mmv = commonState?.mmvList?.[vehicleUsage]
        if (mmv && Object.keys(mmv)?.length) {
            let subType = (type === 'model') ? 'make' : 'model'
            let options = mmv[type]

            if (['model', 'version'].includes(type)) {
                options = options?.filter((e: any) => (e?.[subType] === insuranceState?.createInsurance?.[subType] || e.value === 0))
            }

            setOptions(options)
            setOriginalList(options)
        }
        //eslint-disable-next-line
    }, [commonState?.mmvList, vehicleUsage, type])

    useEffect(() => {
        if(!isCountryId) return
        let key = type + "_name"
        setValue(insuranceState?.createInsurance[key] || '')

        let currentModal = (props.type === 'make') ? 'Make' : (props?.type === 'model' ? 'Model' : "Version")
        setActiveModalName(currentModal)

        let keys = ['make', 'model', 'version']
        let inputFields: any = {}
        for (let key of keys) {
            if (insuranceState?.createInsurance[key] === 0) {
                inputFields[key + "_name"] = insuranceState?.createInsurance[key + "_name"]
            }
        }
        setOtherInputFields(inputFields)

        //eslint-disable-next-line
    }, [insuranceState?.createInsurance, type])

    useEffect(() => {
        if(!isCountryId) return
        if (showOtherPopup) {
            let fieldsToShow: any = (type === 'make') ? ['make', 'model', 'version'] : (type === 'model' ? ['model', 'version'] : ['version'])
            setOtherInputFields((prev: Record<string, string | number>) => {
                let resetFields = fieldsToShow.reduce((acc: Record<string, string | number>, field: string) => {
                    acc[field] = "";
                    acc[field + "_name"] = "";
                    return acc;
                }, { ...prev });
    
                return resetFields;
            });
            setShowOtherPopupFields(fieldsToShow)
        }
        //eslint-disable-next-line
    }, [showOtherPopup, type])

    const handleBack = ()=>{
        if(type==='version'){
            setType('model')
        }else if(type==='model'){
            setType('make')
        }
    }

    

    return (
        <>
            <div className="mmv-modal add-insurnce-search-popup">
                <Modal show={show} handleClose={() => {
                    handleClose()
                    setType('make')
                }} >
                    <div className="modal-header m-sm-b">
                        <h2> { isCountryId  && type!='make' && <span onClick={handleBack}><i className="ic-keyboard_arrow_left"></i></span> } Select {activeModalName}</h2>
                    </div>
                    <div className='modal-body'>
                        <div className="add-insurnace-search-outer">
                            <div className="search-bx">
                                <div className="material">
                                    <input type="text" placeholder=" " name="search_text" className="form-input" title="Search Text" aria-label="Search text" value={value} onChange={(e) => handleSearch(e.target.value)} />
                                    <i className="ic-search"></i>
                                    <label data-label={`Search ${activeModalName}`} className="form-label search-label"></label>
                                </div>
                            </div>
                            {
                                show && options?.length
                                    ?
                                    <div className="searhc-list-outer">
                                        <ul>
                                            {
                                                options?.map((element: any, idx: number) => {
                                                    return (
                                                        <li key={idx + "_" + element.value} onClick={() => handleSelection(element)}>
                                                            <label>{element.label}</label>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                    : undefined
                            }


                        </div>
                    </div>

                </Modal >
            </div >
            <div className='other-mmv-modal'>
                <Modal show={showOtherPopup} handleClose={() => {
                    setShowOtherPopup(false)
                    setOtherErrorFields({})
                    setType('make')
                }}>
                    <div className="modal-header m-b-20">
                        <h2>Select MMV</h2>
                    </div>
                    {
                        otherPopupFields?.map((item: string, idx: any) => {
                            let nameKey = item + "_name"
                            let placeholder = item?.[0] + item.substring(1, item.length)

                            return (
                                <fieldset className={'col-md-12'} key={item + "_" + idx}>
                                    <div className="material">
                                        <input
                                            maxLength={30}
                                            disabled={false}
                                            type={'text'}
                                            placeholder=" "
                                            name={item}
                                            className="form-input"
                                            value={otherInputFields?.[nameKey]}
                                            onChange={(event) => { handleOtherPopupChange(item, event.target.value) }}
                                        />
                                        <label data-label={placeholder} className="form-label"></label>
                                        {otherErrorFields?.[nameKey] ? <span className="error-txt">{otherErrorFields?.[nameKey]}</span> : null}

                                    </div>
                                </fieldset>
                            )
                        })
                    }
                    <div className="col-md-12">
                        <button className="btn-primary " onClick={() => { handleOtherModalSaveClick() }}>Save</button>
                    </div>

                </Modal>
            </div>

        </>
    )
}